// Use this as an alternative to triple brackets
// I.e. use this when you want to pass HTML to a component
// and have it rendered as actual HTML
// Be very careful not to pass any user input to this helper

import Helper from '@ember/component/helper';
import { htmlSafe } from '@ember/template';

export default Helper.helper(function (params) {
  return htmlSafe(params[0]);
});
